import { useState, useEffect } from "react";
import {
  Box,
  FormControlLabel,
  Checkbox,
  Button,
  TextField,
  Autocomplete,
  Typography,
} from "@mui/material";
import { UseProductCluster } from "./UseProductCluster";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate, useLocation } from "react-router-dom";
import ClusterProduct from "./ClusterProduct";
import ClusterBrand from "./ClusterBrand";
import ClusterGroup from "./ClusterGroup";
import ClusterCategory from "./ClusterCategory";
import CheckIcon from "@mui/icons-material/Check";
import ClusterCountry from "./ClusterCountry";
import ClusterTarget from "./ClusterTarget";
import ClusterIngredient from "./ClusterIngredient";
import ClusterPType from "./ClusterPType";
import ClusterColor from "./ClusterColor";
import { removeComma, toMoney } from "../../util/Utils";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditCluster() {
  const navigate = useNavigate();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [sortList, setSortList] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [showBrands, setShowBrands] = useState(false);
  const [showGroups, setShowGroups] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [showCountries, setShowCountries] = useState(false);
  const [showColor, setShowColor] = useState(false);
  const [showPTypes, setShowPTypes] = useState(false);
  const [showIngredients, setShowIngredients] = useState(false);
  const [showTargetLocations, setShowTargetLocations] = useState(false);
  const [expireScale, setExpireScale] = useState(undefined);
  const {
    getclusterSortlist,
    deleteclusterItem,
    getclusterByID,
    validate,
    updatecluster,
    getResultByID,
  } = UseProductCluster();
  const [state, setState] = useState({
    id: undefined,
    available: false,
    withDiscount: false,
    withGift: false,
  });
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const options = [
    { label: "آقایان", id: 1 },
    { label: "بانوان", id: 2 },
  ];

  const LessMore = [
    { id: 1, value: "بیشتر" },
    { id: 2, value: "کمتر" },
  ];

  useEffect(() => {
    if (location.state && location.state.id) {
      setProgress(true);
      getclusterByID(location.state.id, (callback) => {
        if (callback.expireDay && callback.expireDay < 0) {
          setExpireScale(2);
        }
        if (callback.expireDay && callback.expireDay > 0) {
          setExpireScale(1);
        }
        setState(callback);
      });
      getclusterSortlist((sorts) => {
        setSortList(sorts);
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/productcluster" },
          { name: "ویرایش خوشه محصول", url: "/productcluster/editCluster" },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            fullWidth
            error={errorState.title}
            label="عنوان"
            value={state.title ? state.title : ""}
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          {sortList && (
            <Autocomplete
              size="small"
              value={state.sort ? state.sort : undefined}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState({ ...state, sort: newValue });
                } else {
                  setState({ ...state, sort: undefined });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option || option == 0) {
                  return sortList?.find((m) => m.id == option)?.title;
                }
                return "";
              }}
              fullWidth
              options={sortList ? sortList.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField
                  variant="outlined"
                  {...params}
                  label="مرتب سازی بر اساس"
                />
              )}
            />
          )}
        </Box>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <Autocomplete
            size="small"
            value={state.gender ? state.gender : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                setState({ ...state, gender: newValue });
              } else {
                setState({ ...state, gender: undefined });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return options?.find((m) => m.id == option).label;
              }
              return "";
            }}
            sx={{ width: "80%" }}
            fullWidth
            options={options.map((m) => m.id)}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} label="جنسیت" />
            )}
          />
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
          gridColumn={isSmall ? "span 12" : "span 5"}
        >
          <Typography color="secondary" variant="subtitle1">
            قیمت :
          </Typography>
          <TextField
            fullWidth
            sx={{ width: "35%", input: { direction: "rtl" } }}
            label="از"
            value={state.minCost ? toMoney(state.minCost) : ""}
            onChange={(evt) => {
              setState({ ...state, minCost: removeComma(evt.target.value) });
            }}
            size="small"
            variant="outlined"
          />
          <TextField
            fullWidth
            sx={{ width: "35%", input: { direction: "rtl" } }}
            label="تا"
            value={state.maxCost ? toMoney(state.maxCost) : ""}
            onChange={(evt) => {
              setState({ ...state, maxCost: removeComma(evt.target.value) });
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 1"></Box>}{" "}
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
          gridColumn={isSmall ? "span 12" : "span 5"}
        >
          <Typography color="secondary" variant="subtitle1">
            تعداد نمایش در صفحه :
          </Typography>
          <TextField
            sx={{
              input: {
                textAlign: "center",
              },
              width: "30%",
            }}
            label="عدد"
            value={state.gridCount ? state.gridCount : ""}
            onChange={(evt) => {
              if (evt.target.value) {
                setState({
                  ...state,
                  gridCount: evt.target.value,
                });
              } else {
                setState({
                  ...state,
                  gridCount: undefined,
                });
              }
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
          gridColumn={isSmall ? "span 12" : "span 5"}
        >
          <Typography color="secondary" variant="subtitle1">
            تاریخ انقضا :
          </Typography>
          <Autocomplete
            size="small"
            value={expireScale !== undefined ? expireScale : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                if (state.expireDay && newValue == 1) {
                  setState({
                    ...state,
                    expireDay: Math.abs(state.expireDay),
                  });
                } else if (state.expireDay && newValue == 2) {
                  setState({
                    ...state,
                    expireDay: 0 - Math.abs(state.expireDay),
                  });
                }
                setExpireScale(newValue);
              } else {
                setState({
                  ...state,
                  expireDay: undefined,
                });
                setExpireScale(undefined);
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return LessMore?.find((m) => m.id == option).value;
              }
              return "";
            }}
            sx={{ width: "40%" }}
            options={LessMore.map((m) => m.id)}
            renderInput={(params) => (
              <TextField
                sx={{ input: { textAlign: "center" } }}
                variant="outlined"
                {...params}
                label="مقیاس"
              />
            )}
          />
          <Typography color="secondary" variant="subtitle1">
            از
          </Typography>
          <TextField
            sx={{
              input: {
                textAlign: "center",
                // direction: "rtl",
              },
              width: "30%",
            }}
            label="روز"
            value={state.expireDay ? Math.abs(state.expireDay) : ""}
            onChange={(evt) => {
              if (evt.target.value) {
                if (expireScale == 1) {
                  setState({
                    ...state,
                    expireDay: evt.target.value,
                  });
                } else if (expireScale == 2) {
                  setState({
                    ...state,
                    expireDay: 0 - Math.abs(evt.target.value),
                  });
                }
              } else {
                setState({
                  ...state,
                  expireDay: undefined,
                });
              }
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 1"></Box>}{" "}
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
          gridColumn={isSmall ? "span 12" : "span 3"}
        >
          <Typography color="secondary" variant="subtitle1">
            spf :
          </Typography>
          <TextField
            fullWidth
            label="spf"
            sx={{ width: "50%", input: { textAlign: "center" } }}
            value={state.spf ? state.spf : ""}
            onChange={(evt) => {
              setState({ ...state, spf: evt.target.value });
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        <Box gridColumn="span 5"></Box>
        <Box gridColumn="span 12">
          <FormControlLabel
            checked={state.available ? state.available : false}
            onChange={(evt) => {
              setState({ ...state, available: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات موجود"
          />
          <FormControlLabel
            checked={state.withDiscount ? state.withDiscount : false}
            onChange={(evt) => {
              setState({ ...state, withDiscount: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات با تخفیف"
          />
          <FormControlLabel
            checked={state.withGift ? state.withGift : false}
            onChange={(evt) => {
              setState({ ...state, withGift: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات با هدیه"
          />
        </Box>
        <Box sx={{ mt: 1 }} gridColumn="span 12">
          <FormControlLabel
            checked={state.isherbal ? state.isherbal : false}
            onChange={(evt) => {
              setState({ ...state, isherbal: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات گیاهی"
          />
          <FormControlLabel
            checked={state.isNatural ? state.isNatural : false}
            onChange={(evt) => {
              setState({ ...state, isNatural: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات طبیعی"
          />
          <FormControlLabel
            checked={state.isTraditional ? state.isTraditional : false}
            onChange={(evt) => {
              setState({ ...state, isTraditional: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات طب سنتی"
          />
        </Box>
        <Box gridColumn="span 7"></Box>
        <Box gridColumn="span 12">
          <Button
            onClick={() => setShowProducts(true)}
            variant="contained"
            color="secondary"
            sx={{
              width: "140px",
              mr: 1,
              mb: 1,
            }}
          >
            {state.products && state.products.length ? (
              <CheckIcon fontSize="small" />
            ) : (
              ""
            )}
            فیلتر محصول
          </Button>
          <Button
            onClick={() => setShowBrands(true)}
            variant="contained"
            color="secondary"
            sx={{
              width: "140px",
              mr: 1,
              mb: 1,
            }}
          >
            {state.brands && state.brands.length ? (
              <CheckIcon fontSize="small" />
            ) : (
              ""
            )}
            فیلتر برند
          </Button>
          <Button
            onClick={() => setShowGroups(true)}
            variant="contained"
            color="secondary"
            sx={{
              width: "140px",
              mr: 1,
              mb: 1,
            }}
          >
            {state.groups && state.groups.length ? (
              <CheckIcon fontSize="small" />
            ) : (
              ""
            )}
            فیلتر گروه
          </Button>

          <Button
            onClick={() => setShowCategories(true)}
            color="secondary"
            variant="contained"
            sx={{
              width: "140px",
              mr: 1,
              mb: 1,
            }}
          >
            {state.categories && state.categories.length ? (
              <CheckIcon fontSize="small" />
            ) : (
              ""
            )}
            فیلتر دسته
          </Button>
        </Box>
        <Box gridColumn="span 12">
          <Button
            onClick={() => setShowCountries(true)}
            color="secondary"
            variant="contained"
            sx={{
              width: "140px",
              mr: 1,
              mb: 1,
            }}
          >
            {state.countries && state.countries.length ? (
              <CheckIcon fontSize="small" />
            ) : (
              ""
            )}
            فیلتر کشور
          </Button>
          <Button
            onClick={() => setShowTargetLocations(true)}
            color="secondary"
            variant="contained"
            sx={{
              width: "140px",
              mr: 1,
              mb: 1,
            }}
          >
            {state.targetLocations && state.targetLocations.length ? (
              <CheckIcon fontSize="small" />
            ) : (
              ""
            )}
            فیلتر محل مصرف
          </Button>
          <Button
            onClick={() => setShowColor(true)}
            color="secondary"
            variant="contained"
            sx={{
              width: "140px",
              mr: 1,
              mb: 1,
            }}
          >
            {state.colors && state.colors.length ? (
              <CheckIcon fontSize="small" />
            ) : (
              ""
            )}
            فیلتر رنگ
          </Button>
          <Button
            onClick={() => setShowPTypes(true)}
            color="secondary"
            variant="contained"
            sx={{
              width: "140px",
              mr: 1,
              mb: 1,
            }}
          >
            {state.productTypes && state.productTypes.length ? (
              <CheckIcon fontSize="small" />
            ) : (
              ""
            )}
            فیلتر نوع محصول
          </Button>
          <Button
            onClick={() => setShowIngredients(true)}
            color="secondary"
            variant="contained"
            sx={{
              width: "140px",
              mr: 1,
              mb: 1,
            }}
          >
            {state.ingredients && state.ingredients.length ? (
              <CheckIcon fontSize="small" />
            ) : (
              ""
            )}
            فیلتر ترکیبات
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 3,
          }}
          gridColumn="span 12"
        >
          <Button
            color="secondary"
            variant="contained"
            sx={{ width: "100px" }}
            onClick={() => {
              setProgress(true);
              getResultByID(state && state.id, (callback) => {
                window.open(callback, "_blank");
              });
            }}
          >
            نمایش
          </Button>
          <Button
            variant="contained"
            sx={{ mx: 2, width: "100px" }}
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                updatecluster(state, (callback) => {
                  navigate("/productcluster", {
                    state: location.state,
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            color="secondary"
            variant="outlined"
            onClick={() => {
              navigate("/productcluster", {
                state: location.state,
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>

      {showProducts && (
        <ClusterProduct
          rows={state.products ?? []}
          setShowProducts={setShowProducts}
          showProducts={showProducts}
          ClusterID={state.id}
          deleteCallback={(id) => {
            deleteclusterItem(id, (callback) => {
              setProgress(true);
              getclusterByID(state.id, (callback) => {
                setState(callback);
              });
            });
          }}
          callback={(id) => {
            getclusterByID(state.id, (callback) => {
              setState(callback);
            });
          }}
        />
      )}
      {showBrands && (
        <ClusterBrand
          rows={state.brands ?? []}
          setShowBrands={setShowBrands}
          showBrands={showBrands}
          ClusterID={state.id}
          deleteCallback={(id) => {
            deleteclusterItem(id, (callback) => {
              setProgress(true);
              getclusterByID(state.id, (callback) => {
                setState(callback);
              });
            });
          }}
          callback={(id) => {
            getclusterByID(state.id, (callback) => {
              setState(callback);
            });
          }}
        />
      )}

      {showGroups && (
        <ClusterGroup
          rows={state.groups ?? []}
          setShowGroups={setShowGroups}
          showGroups={showGroups}
          ClusterID={state.id}
          deleteCallback={(id) => {
            deleteclusterItem(id, (callback) => {
              setProgress(true);
              getclusterByID(state.id, (callback) => {
                setState(callback);
              });
            });
          }}
          callback={(id) => {
            getclusterByID(state.id, (callback) => {
              setState(callback);
            });
          }}
        />
      )}
      {showCategories && (
        <ClusterCategory
          rows={state.categories ?? []}
          setShowCategories={setShowCategories}
          showCategories={showCategories}
          ClusterID={state.id}
          deleteCallback={(id) => {
            deleteclusterItem(id, (callback) => {
              setProgress(true);
              getclusterByID(state.id, (callback) => {
                setState(callback);
              });
            });
          }}
          callback={(id) => {
            getclusterByID(state.id, (callback) => {
              setState(callback);
            });
          }}
        />
      )}
      {showCountries && (
        <ClusterCountry
          rows={state.countries ?? []}
          setShowCountries={setShowCountries}
          showCountries={showCountries}
          ClusterID={state.id}
          deleteCallback={(id) => {
            deleteclusterItem(id, (callback) => {
              setProgress(true);
              getclusterByID(state.id, (callback) => {
                setState(callback);
              });
            });
          }}
          callback={(id) => {
            getclusterByID(state.id, (callback) => {
              setState(callback);
            });
          }}
        />
      )}
      {showTargetLocations && (
        <ClusterTarget
          rows={state.targetLocations ?? []}
          setShow={setShowTargetLocations}
          show={showTargetLocations}
          ClusterID={state.id}
          deleteCallback={(id) => {
            deleteclusterItem(id, (callback) => {
              setProgress(true);
              getclusterByID(state.id, (callback) => {
                setState(callback);
              });
            });
          }}
          callback={(id) => {
            getclusterByID(state.id, (callback) => {
              setState(callback);
            });
          }}
        />
      )}
      {showColor && (
        <ClusterColor
          rows={state.colors ?? []}
          setShow={setShowColor}
          show={showColor}
          ClusterID={state.id}
          deleteCallback={(id) => {
            deleteclusterItem(id, (callback) => {
              setProgress(true);
              getclusterByID(state.id, (callback) => {
                setState(callback);
              });
            });
          }}
          callback={(id) => {
            getclusterByID(state.id, (callback) => {
              setState(callback);
            });
          }}
        />
      )}
      {showPTypes && (
        <ClusterPType
          rows={state.productTypes ?? []}
          setShow={setShowPTypes}
          show={showPTypes}
          ClusterID={state.id}
          deleteCallback={(id) => {
            deleteclusterItem(id, (callback) => {
              setProgress(true);
              getclusterByID(state.id, (callback) => {
                setState(callback);
              });
            });
          }}
          callback={(id) => {
            getclusterByID(state.id, (callback) => {
              setState(callback);
            });
          }}
        />
      )}
      {showIngredients && (
        <ClusterIngredient
          rows={state.ingredients ?? []}
          setShow={setShowIngredients}
          show={showIngredients}
          ClusterID={state.id}
          deleteCallback={(id) => {
            deleteclusterItem(id, (callback) => {
              setProgress(true);
              getclusterByID(state.id, (callback) => {
                setState(callback);
              });
            });
          }}
          callback={(id) => {
            getclusterByID(state.id, (callback) => {
              setState(callback);
            });
          }}
        />
      )}
    </Detail>
  );
}
